<template>
    <div class="box shadow-md rounded-lg tab-content">
        <div
            class="nav nav-tabs flex-col sm:flex-row justify-center lg:justify-start px-4 border-b border-theme-43"
            role="tablist"
        >
            <a
                :id="`${id}-${key}`"
                data-toggle="tab"
                href="javascript:;"
                class="py-4 sm:mr-8 text-base font-semibold text-theme-37"
                :class="{'active' : currentTabActive == tab.name}"
                role="tab"
                aria-selected="false"
                @click="tabClick(tab.tab, tab.name)"
                v-for="(tab,key) in TabArray"
                :key="key"
            >
                {{tab.name}}
            </a>
            <div
                class="flex-grow flex justify-end items-center justify-self-end self-center my-2"
            >
                <slot name="nav-right"/>
            </div>
        </div>
        <!-- tab content -->
        <slot name="tab-content"/>
    </div>
</template>

<script setup>
import { ref } from "vue"

const props = defineProps({
  id: {
    type: String,
    require: true,
  },
  TabArray: Array,
  currentTabText: {
    type: String,
    require: true,
  }
});
const emits = defineEmits(["currentTab"]);
const currentTabActive = ref()
currentTabActive.value = props.currentTabText
const tabClick = (tab, text) => {
    currentTabActive.value = text
    emits('currentTab', {tab,text})
};
</script>

<style>

</style>